import script from "./ValidationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationPage.vue?vue&type=script&setup=true&lang=js"

import "./ValidationPage.vue?vue&type=style&index=0&id=61947fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61947fc6"]])

export default __exports__